exports.HIGH_TEMPERATURE_EMAIL = 'highTemperatureEmail'
exports.CHANGE_SOAP_EMAIL = 'changeSoapEmail'
exports.NOTIFICATION_TYPE = 'notificationType'
